import React, {useCallback, useEffect} from 'react';
import {RootStackBindingProps} from '../RootStack/RootStackBindingProps';
import {observer} from 'mobx-react-lite';
import {useRoot} from '../../Root/hooks';

import {expr} from 'mobx-utils';
import {useSafelyGoBack} from '../hooks';
import FreeMinerScreen from '../../FreeMinerScreen/FreeMinerScreen';

export type FreeMinerBindingProps = RootStackBindingProps<'FreeMiner'>;

export default observer(function FreeMinerBinding() {
  const {dashboardSlotBacklight, freeMinerState, windowDimensionsState} =
    useRoot();
  const safelyGoBack = useSafelyGoBack();
  const slotLayout = dashboardSlotBacklight.slotLayout;
  const visible = expr(() => dashboardSlotBacklight.visible);
  const isDesktop = expr(() => windowDimensionsState.window.width > 1100);
  useEffect(() => {
    freeMinerState.showSlotBacklight();
    if (!freeMinerState.canShowFreeMinerBacklight) {
      safelyGoBack();
    } else {
      freeMinerState.setWasShownFreeMinerBacklight();
    }
  }, [freeMinerState, safelyGoBack]);
  const onClose = useCallback(() => {
    freeMinerState.closeSlotBacklight();
    safelyGoBack();
  }, [freeMinerState, safelyGoBack]);

  return visible && slotLayout ? (
    <FreeMinerScreen
      layout={slotLayout}
      onClose={onClose}
      isDesktop={isDesktop}
    />
  ) : null;
});
